export default __webpack_public_path__ + "static/media/icon_guide_cancel.6fd8d43b.svg";